import appConfig from './env';
import { OpenFileRequestBody } from '../types/types';
import { OpenOptions } from './openOptions';

export const isPdfViewerServiceEnabled = (): boolean => appConfig.PDF_VIEWER_ENGINE === 'pdf-viewer';

export const withViewerEngine = (body: OpenFileRequestBody): OpenFileRequestBody => (
    body.app_name === OpenOptions.viewer && isPdfViewerServiceEnabled()
        ? { ...body, viewer_engine: 'pdf-viewer' }
        : body
);
